/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".carousel-title[_ngcontent-%COMP%]{font-family:SEGOEUIL,\"Helvetica Neue\",sans-serif;font-size:22px;font-weight:400;margin-top:40px;margin-bottom:2px;line-height:48px}.catories-children-all[_ngcontent-%COMP%]{margin-left:auto;width:auto;color:#26809d}.category-slider-row[_ngcontent-%COMP%]{margin-top:1em}.loading[_ngcontent-%COMP%]{position:absolute;height:100%;width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/categories/categories.component.scss.shim.ngstyle.js.pre-build-optimizer.js